"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = TableHeader;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const crate_1 = require("@tcc/crate");
const react_table_1 = require("@tanstack/react-table");
const tableHeader_css_1 = require("./tableHeader.css");
const tableUtils_1 = require("../../utils/tableUtils");
function TableHeader({ tableState, getHeaderGroups, isReady }) {
    const multipleSortedColumns = tableState.sorting.length > 1;
    return (react_1.default.createElement("thead", { className: tableHeader_css_1.tableHeader }, getHeaderGroups().map((headerGroup) => (react_1.default.createElement("tr", { key: headerGroup.id }, headerGroup.headers.map((header) => {
        const isSortable = header.column.getCanSort();
        const isSorted = header.column.getIsSorted();
        const sortIcon = isSorted ? (react_1.default.createElement(crate_1.Icon, { glyph: crate_1.Icon.set.ARROW_BACK, className: {
                asc: tableHeader_css_1.ascSorting,
                desc: tableHeader_css_1.descSorting,
            }[isSorted] })) : null;
        const sortIndex = isSorted && multipleSortedColumns ? header.column.getSortIndex() + 1 : null;
        const { id } = header.column;
        const testId = `fds-table-header-${id}`;
        return (react_1.default.createElement("th", { key: id, "data-test-id": testId, className: (0, classnames_1.default)(tableHeader_css_1.tableHeaderCell, { [tableHeader_css_1.sortableTableHeaderCell]: isSortable }), style: Object.assign({}, (0, tableUtils_1.getCommonPinningStyles)(header.column, isReady)), onClick: isSortable ? header.column.getToggleSortingHandler() : undefined },
            react_1.default.createElement("div", null, isReady ? (react_1.default.createElement(react_1.default.Fragment, null,
                (0, react_table_1.flexRender)(header.column.columnDef.header, header.getContext()),
                sortIcon,
                sortIndex)) : (react_1.default.createElement(crate_1.Skeleton, { height: 16 })))));
    }))))));
}
